// extracted by mini-css-extract-plugin
export default {"dot":"MW-z","dotSelected":"NW-z","dots":"OW-z","dotsContainer":"PW-z","leftArrowBtn":"QW-z","rightArrowBtn":"RW-z","arrowLeft":"SW-z","arrowDisabled":"TW-z"};